import styled from 'styled-components';

export const QuestionsAnswersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  padding-bottom: 1.5rem;
`;

export const AccordionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.0625rem;
  width: 90%;

  h4 {
    margin-bottom: 0;
  }
`;
